import BulkProcessService from "../services/bulkProcessService";
import {
  POLLING_DATA_FILE,
  BATCH_STATUS_POLLING,
  DEAFULT_PROCESSING_STATUS,
  FILE_UPLOAD_ERROR_CODE,
} from "../constants/bulkProcessConstant";
import { NotificationManager } from "react-notifications";
import { updateUserBalanceByThunk } from "./userAction";

export const resetBulkUploadData = () => {
  return {
    type: "RESET_BULK_UPLOAD_DATA",
  };
};

export const updateBulkUploadFileUploader = (uploading) => {
  return {
    type: "UPDATE_BULK_LOADER",
    payload: uploading,
  };
};

export const updateBulkScreen = (activeScreen) => {
  return {
    type: "UPDATE_BULK_SCREEN",
    payload: activeScreen,
  };
};

export const updateCxmlData = (cxmlData) => {
  return {
    type: "UPDATE_CXML_DATA",
    payload: cxmlData,
  };
};

export const updateBulkProcessing = (processing) => {
  return {
    type: "UPDATE_BULK_PROCESSING",
    payload: processing,
  };
};

export const updateBulkPayment = (showBulkPayment) => {
  return {
    type: "UPDATE_BULK_PAYMENT",
    payload: showBulkPayment,
  };
};

export const updateSkipFileCheck = (skipFileCheck) => {
  return {
    type: "UPDATE_SKIP_FILE_CHECK",
    payload: skipFileCheck,
  };
};

export const updateBulkScreenError = (uploadFileErr) => {
  return {
    type: "UPDATE_BULK_SCREEN_ERROR",
    payload: uploadFileErr,
  };
};

export const updateBulkScreenMsg = (uploadFileMsg) => {
  return {
    type: "UPDATE_BULK_SCREEN_MSG",
    payload: uploadFileMsg,
  };
};

export const updateBulkUploadFormData = (bulkUploadData) => {
  return {
    type: "UPDATE_BULK_UPLOAD_DATA",
    payload: { formData: bulkUploadData },
  };
};

export const updateFileName = (fileName) => {
  return {
    type: "UPDATE_BULK_FILE_NAME",
    payload: fileName,
  };
};

export const updateBulkBtachId = (batchId) => {
  return {
    type: "UPDATE_BULK_FILE_BATCHID",
    payload: batchId,
  };
};

export const updateFileProcessData = (batchProcessData) => {
  return {
    type: "UPDATE_BULK_FILE_PROCESS_DATA",
    payload: { batchProcessData: batchProcessData },
  };
};

export const updateProcessedBulkData = (bulkProcessData) => {
  return {
    type: "UPDATE_BULK_PROCESS_DATA",
    payload: { bulkProcessData },
  };
};

export const updateProcessedBulkStatus = (bulkProcessStatus) => {
  return {
    type: "UPDATE_BULK_PROCESS_STATUS",
    payload: { bulkProcessStatus },
  };
};

export const uploadFileDataV1 = (params) => (dispatch) => {
  let fileErr = "";
  let batchId = "";
  dispatch(updateBulkUploadFileUploader(true));
  dispatch(updateBulkScreen(0));
  dispatch(updateBulkScreenMsg(fileErr));
  BulkProcessService.uploadFile(params)
    .then((response) => {
      if (
        response &&
        response.hasOwnProperty("data") &&
        response.data.hasOwnProperty("batch_id")
      ) {
        batchId = response.data.batch_id;
        fileErr = "";
        let data = {
          batch_id: batchId,
          reward_type: params.reward_type,
        };
        dispatch(checkBatchStatus(data));
        response?.xml && dispatch(updateCxmlData(response?.xml));
      } else if (
        response &&
        response.hasOwnProperty("error") &&
        response.hasOwnProperty("errors") &&
        response.errors.hasOwnProperty("msg") &&
        response.error == true
      ) {
        if (
          response.errCode &&
          FILE_UPLOAD_ERROR_CODE.includes(response.errCode)
        ) {
          dispatch(updateSkipFileCheck(true));
        }
        fileErr = response.errors.msg || response.data || "";
        dispatch(updateBulkScreenError(response.errCode));
        dispatch(updateBulkScreen(0));
        dispatch(updateBulkUploadFileUploader(false));
        dispatch(updateBulkProcessing(DEAFULT_PROCESSING_STATUS.INACTIVE));
      } else {
        fileErr = "Something Went Wrong";
        dispatch(updateBulkScreen(0));
        dispatch(updateBulkUploadFileUploader(false));
        dispatch(updateBulkProcessing(DEAFULT_PROCESSING_STATUS.INACTIVE));
      }
    })
    .catch((err) => {
      console.log(err);
    })
    .then(() => {
      // dispatch(updateBulkUploadFileUploader(false))
      dispatch(updateBulkScreenMsg(fileErr));
      dispatch(updateBulkBtachId(batchId));
    });
};

export const checkBatchStatus = (data) => (dispatch, getState) => {
  let { accountReducer: { userBalance: { userBalance = 0 } = {} } = {} } =
    getState();
  const processing = [
    BATCH_STATUS_POLLING.VALIDATION_IN_PROGRESS,
    BATCH_STATUS_POLLING.BATCH_CREATED,
  ];
  const failStatus = [
    BATCH_STATUS_POLLING.FAILURE,
    BATCH_STATUS_POLLING.VALIDATION_FAILURE,
    BATCH_STATUS_POLLING.CANCELLED,
  ];
  dispatch(updateBulkUploadFileUploader(true));
  BulkProcessService.getBatchStatus(data)
    .then((response) => {
      if (
        response &&
        response.bulkProcessGetBatchStatus &&
        response.bulkProcessGetBatchStatus.data &&
        !response.bulkProcessGetBatchStatus.error
      ) {
        // suceess case
        let processData = response.bulkProcessGetBatchStatus.data;
        let fileErr = "";
        if (processData.status == BATCH_STATUS_POLLING.VALIDATION_SUCCESS) {
          dispatch(
            updateFileProcessData(response.bulkProcessGetBatchStatus.data)
          );
          dispatch(
            updateBulkProcessing(DEAFULT_PROCESSING_STATUS.STATUS_SUCCESS)
          );
          dispatch(updateBulkScreenMsg(fileErr));
          dispatch(updateBulkScreen(1));
          dispatch(updateBulkUploadFileUploader(false));
        } else if (processing.includes(processData.status)) {
          setTimeout(
            function () {
              dispatch(checkBatchStatus(data));
            }.bind(this),
            3000
          );
          // fileErr = "Validating File. Please wait..."
          // dispatch(updateBulkScreenMsg(fileErr))
        } else if (failStatus.includes(processData.status)) {
          // debugger
          if (
            processData.insufficient_fund ||
            processData.insufficient_threshold
          ) {
            dispatch(updateBulkPayment(true));
          }
          // if(processData.currentAmount > userBalance){
          // 	dispatch(updateBulkPayment(true))
          // 	fileErr = "Insufficient Balance"
          // }else{
          // 	fileErr = "Unable to validate file,Remove file and reupload"
          // }
          // dispatch(updateBulkScreenMsg(fileErr))
          dispatch(updateBulkScreen(1));
          dispatch(updateBulkUploadFileUploader(false));
          dispatch(
            updateFileProcessData(response.bulkProcessGetBatchStatus.data)
          );
          dispatch(
            updateBulkProcessing(DEAFULT_PROCESSING_STATUS.STATUS_FAILURE)
          );
        } else {
          // dispatch(updateFileProcessData(response.bulkProcessGetBatchStatus.data))
          fileErr = response.bulkProcessGetBatchStatus.message
            ? response.bulkProcessGetBatchStatus.message[0]
            : "Something went wrong!!";
          dispatch(
            updateBulkProcessing(DEAFULT_PROCESSING_STATUS.STATUS_FAILURE)
          );
          dispatch(updateBulkScreenMsg(fileErr));
          dispatch(updateBulkScreen(1));
          dispatch(updateBulkUploadFileUploader(false));
        }
      } else {
        let msg =
          response &&
          response.bulkProcessGetBatchStatus &&
          response.bulkProcessGetBatchStatus.message[0] &&
          response.bulkProcessGetBatchStatus.message[0];
        dispatch(updateBulkScreenMsg(msg));
        dispatch(updateBulkScreen(0));
      }
    })
    .catch((err) => {
      console.log(err);
    })
    .then(() => {});
};

export const createPunchoutForm = ({ data, url }) => {
  const form = document.createElement("form");
  form.setAttribute("hidden", "true");
  form.setAttribute("method", "POST");
  form.setAttribute("action", url);
  Object.keys(data).forEach((key) => {
    const input1 = document.createElement("input");
    input1.setAttribute("type", "text");
    input1.setAttribute("name", key);
    input1.setAttribute("value", data[key]);
    form.appendChild(input1);
  });
  document.body.appendChild(form);
  return form;
};

export const startBulkProcess =
  (params, bulkProcessDataorg = [], fileName, uploadAgain) =>
  (dispatch, getState) => {
    let {
      bulkProcessReducer: {
        bulkProcessData = [],
        bulkUploadData: { batchProcessData: { is_scheduler = 0 } = {} } = {},
      },
      accountReducer: { clientId = "" },
    } = getState();
    let a2 = [...bulkProcessData];
    dispatch(
      updateBulkProcessing(DEAFULT_PROCESSING_STATUS.PROCESSING_STARTED)
    );
    // if(is_scheduler){
    // 	let pollingData = JSON.parse(JSON.stringify(POLLING_DATA_FILE));
    // 	pollingData.batch_id = params.batch_id;
    // 	pollingData.reward_type = params.reward_type
    // 	pollingData.fileName = fileName
    // 	a2.push(pollingData)
    // 	dispatch(updateBulkProcessing(DEAFULT_PROCESSING_STATUS.PROCESSING_FINISHED))
    // 	dispatch(updateProcessedBulkData(a2))
    // }else{
    // 	BulkProcessService.bulkProcess(params)
    // 	.then((response) => {
    // 		if(response && response.bulkProcess && !response.bulkProcess.error){
    // 			// NotificationManager.success("Bulk process started successfully")
    // 			dispatch(updateBulkProcessing(DEAFULT_PROCESSING_STATUS.PROCESSING_FINISHED))
    // 			let pollingData = JSON.parse(JSON.stringify(POLLING_DATA_FILE));
    // 			pollingData.batch_id = params.batch_id;
    // 			pollingData.reward_type = params.reward_type
    // 			pollingData.fileName = fileName
    // 			a2.push(pollingData)
    // 			// dispatch(updateProcessedBulkData(bulkProcessData))
    // 		}else if(response && response.bulkProcess && response.error){
    // 			let msg = response.error && response.errors && response.errors.msg ? response.errors.msg : "Could not process Request!!"
    // 			NotificationManager.error(msg)
    // 		}else{
    // 			NotificationManager.error("Could not process Request")
    // 		}
    // 	}).catch((err) => {
    // 		console.log("Err",err)
    // 	}).then(() => {
    // 		dispatch(updateProcessedBulkData(a2))
    // 	})
    // }

    // dispatch(resetBulkUploadData())

    BulkProcessService.bulkProcess(params)
      .then((response) => {
        if (response && response.bulkProcess && !response.bulkProcess.error) {
          // NotificationManager.success("Bulk process started successfully")
          dispatch(
            updateBulkProcessing(DEAFULT_PROCESSING_STATUS.PROCESSING_FINISHED)
          );
          if (response.bulkProcess?.data?.punchout_cart_data) {
            const punchoutCartData =
              response.bulkProcess?.data?.punchout_cart_data;
            if (punchoutCartData?.response?.data) {
              punchoutCartData.response.data = JSON.parse(
                punchoutCartData?.response?.data
              );
            }

            dispatch(updateCxmlData(punchoutCartData));
            const form = createPunchoutForm(punchoutCartData?.response);
            dispatch(updateCxmlData(punchoutCartData));
            setTimeout(() => {
              form.submit();
              form.onerror = () =>
                NotificationManager.error(
                  "Could not process Request. Try uploading again."
                );
              // form.onsubmit = () => dispatch(updateCxmlData(punchoutCartData));
            }, 5000);
          } else {
            let pollingData = JSON.parse(JSON.stringify(POLLING_DATA_FILE));
            pollingData.batch_id = params.batch_id;
            pollingData.reward_type = params.reward_type;
            pollingData.fileName = fileName;
            pollingData.client_id = clientId;
            a2.push(pollingData);
            // dispatch(updateProcessedBulkData(bulkProcessData))
          }
        } else if (
          response &&
          response.bulkProcess &&
          response.bulkProcess.error
        ) {
          if (response.bulkProcess.errCode === "PBB11005") {
            uploadAgain();
          }
          let msg =
            response.bulkProcess.error &&
            response.bulkProcess.errors &&
            response.bulkProcess.errors.msg
              ? response.bulkProcess.errors.msg
              : "Could not process Request!!";
          NotificationManager.error(msg);
        } else {
          NotificationManager.error("Could not process Request");
        }
      })
      .catch((err) => {
        console.log("Err", err);
      })
      .then(() => {
        dispatch(updateProcessedBulkData(a2));
      });
  };

export const checkPollingData =
  (bulkProcessDataOrg) => (dispatch, getState) => {
    let {
      bulkProcessReducer: { bulkProcessData = [], bulkProcessStatus = [] },
    } = getState();
    let statusToSkip = [
      BATCH_STATUS_POLLING.FAILURE,
      BATCH_STATUS_POLLING.VALIDATION_FAILURE,
      BATCH_STATUS_POLLING.CANCELLED,
      BATCH_STATUS_POLLING.COMPLETE,
    ];
    let promises = [];
    bulkProcessData.map(async (processData, index) => {
      // console.log("state",state,localState[state])
      let params = {
        batch_id: processData.batch_id,
        reward_type: processData.reward_type,
      };
      if (typeof bulkProcessStatus[index] === "undefined") {
        // does not exist so push for polling
        promises.push(BulkProcessService.getBatchStatus(params));
      } else {
        // does exist
        //remove this after abhiram change && processData.reward_type !== 3
        if (
          !statusToSkip.includes(bulkProcessStatus[index].status) &&
          bulkProcessStatus[index].is_scheduler != 1
        ) {
          promises.push(BulkProcessService.getBatchStatus(params));
        } else {
          promises.push(Promise.resolve(null));
        }
      }
    });
    let bulkProcessStatusTemp = [...bulkProcessStatus];
    promises &&
      promises.length &&
      Promise.all(promises)
        .then((resp) => {
          resp &&
            resp.length &&
            resp.map((response, index) => {
              if (
                response &&
                response.bulkProcessGetBatchStatus &&
                response.bulkProcessGetBatchStatus.data &&
                !response.bulkProcessGetBatchStatus.error
              ) {
                // suceess case
                let processData = response.bulkProcessGetBatchStatus.data;
                if (typeof bulkProcessStatusTemp[index] === "undefined") {
                  bulkProcessStatusTemp.push(processData);
                } else {
                  bulkProcessStatusTemp[index] = processData;
                }
                if (statusToSkip.includes(processData.status)) {
                  dispatch(updateUserBalanceByThunk());
                }
              } else {
                if (typeof bulkProcessStatusTemp[index] === "undefined") {
                  bulkProcessStatusTemp.push({});
                } else {
                  bulkProcessStatusTemp[index] = bulkProcessStatus[index];
                }
                // let msg = response && response.bulkProcessGetBatchStatus && response.bulkProcessGetBatchStatus.message[0] && response.bulkProcessGetBatchStatus.message[0]
                // dispatch(updateBulkScreenMsg(msg))
                // dispatch(updateBulkScreen(0))
              }
            });
        })
        .catch((err) => {
          console.log("err", err);
        })
        .then(() => {
          dispatch(updateProcessedBulkStatus(bulkProcessStatusTemp));
        });
  };